import { combineReducers } from '@fullstory/redux-util/utils';
import { createRequestReducer } from '@fullstory/redux-util';
import { ContactsRequestTypes } from './types';
import { GetContactsResponse } from '@fullstory/proto/fs/services/orgs/orgs.proto';

const org = createRequestReducer<GetContactsResponse>()(
  ContactsRequestTypes.GetOrgContactsRequest,
  ContactsRequestTypes.GetOrgContactsSuccess,
  ContactsRequestTypes.GetOrgContactsFailure,
);

const umbrella = createRequestReducer<GetContactsResponse>()(
  ContactsRequestTypes.GetUmbrellaContactsRequest,
  ContactsRequestTypes.GetUmbrellaContactsSuccess,
  ContactsRequestTypes.GetUmbrellaContactsFailure,
);

type ContactsReducerState = {
  org: ReturnType<typeof org>;
  umbrella: ReturnType<typeof umbrella>;
};

export const contactsReducer = combineReducers<ContactsReducerState>({
  org,
  umbrella,
});
